import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '~/App';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Provider } from 'react-redux';

import reportWebVitals from './reportWebVitals';
import store from './store';
import GlobalStyle from './components/GlobalStyles';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GlobalStyle>
        <App />
      </GlobalStyle>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
